<div class="text-center loading-list">
    <mat-spinner></mat-spinner>
</div>